const host =process.env.REACT_APP_API_BASE_URL;

export const getInitials = (fullName) => {
  if (!fullName) return '';
  return fullName
    .trim()
    .split(/\s+/) // split by any number of spaces
    .slice(0, 2) // take at most first two words
    .map(word => word.charAt(0).toUpperCase())
    .join('');
};


export const CurrentUserId= localStorage.getItem("userId");
export const CurrentUserName= localStorage.getItem("userName");
export const currentUserRole= localStorage.getItem("role");
export const StaticUploadPath=`${host}/uploaded_images`;